import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import qrModule, { qrSesionPlugin } from "./modules/qr/storeQr";

import adminHomeModule from  "./modules/adminHome/storeHome";    
import customizationModule from  "./modules/adminHome/storeHomeCMS";    
import alertPushModule from  "./modules/alertPush/storeAlertPush";    
import benefitModule from  "./modules/benefit/storeBenefits";    
import birthsModule from  "./modules/births/storeBirths";    
import cultureModule from  "./modules/culture/storeCulture";    
import docsModule from  "./modules/docs/storeDocs";    
import encuestasModule from  "./modules/encuestas/storeEncuestas";    
import eppModule from  "./modules/epp/storeEpp";    
import galleryModule from  "./modules/gallery/storeGallery";    
import hotelsModule from  "./modules/hotels/storeHotels";    
import loginModule from  "./modules/login/storeLogin";    
import { mailHistoryPlugin } from  "./modules/mail/create";    
import mailsModule from  "./modules/mail/index";    
import newsModule from  "./modules/news/storeNews";    
import newsTitlesModule from  "./modules/news/storeNewsTitles";    
import organigramaModule from  "./modules/organigrama/storeOrganigrama";    
import profileModule from  "./modules/profile/storeProfile";    
import recognizeModule from  "./modules/recognize/storeRecognize";    
import safetyModule from  "./modules/safety/storeSafety";    
import sidebar from  "./modules/sidebar/storeSidebar";    
import transporteModule from  "./modules/transporte/storeTransporte";    
import tvCorporativaModule from  "./modules/tv/storeAddContent";    
import canalCorporativoModule from  "./modules/tv/storeTV";    
import tvIndicadoresModule from  "./modules/tv/tvIndicadoresModule";    
import usersModule from  "./modules/users/storeUsers";    
import videoModule from  "./modules/videos/storeVideos";    
import videoCatModule from  "./modules/videos/storeVideosCategories";    
import wallModule from  "./modules/wall/storeWall";    
import WallPerfiles from  "./modules/wall/storeWallPerfiles";    
import Indicadores from  "./modules/indicadores/storeIndicadores";    
import terminos from "./modules/terminos/storeTerminos";

export default new Vuex.Store({
    state: {
        heavyLibrariesLoaded: false
    },
    plugins: [mailHistoryPlugin, qrSesionPlugin],
    mutations: {
        SET_HEAVY_LIBRARIES_LOADED(state, payload) {
            state.heavyLibrariesLoaded = payload;
        }
    },
    actions: {
        setHeavyLibrariesLoaded({ commit }, payload) {
            commit('SET_HEAVY_LIBRARIES_LOADED', payload);
        }
    },
    getters: {
        heavyLibrariesLoaded: state => state.heavyLibrariesLoaded,
        isComponentAvailable: (state) => (componentName) => {
            if (!state.heavyLibrariesLoaded) return false;
            const globalComponents = Vue.options.components || {};
            const hasGlobalComponent = globalComponents[componentName] || globalComponents[componentName.toLowerCase()];
            if (componentName === 'VDatePicker' || componentName === 'v-date-picker') {
                return hasGlobalComponent || (globalComponents.VDatePicker || globalComponents['v-date-picker']);
            }
            
            return !!hasGlobalComponent;
        }
    },
    modules: {
        qrModule,
        mailsModule,
        hotelsModule,
        newsModule,
        newsTitlesModule,
        galleryModule,
        usersModule,
        cultureModule,
        recognizeModule,
        benefitModule,
        docsModule,
        safetyModule,
        encuestasModule,
        eppModule,
        alertPushModule,
        transporteModule,
        adminHomeModule,
        wallModule,
        WallPerfiles,
        Indicadores,
        sidebar,
        videoModule,
        videoCatModule,
        organigramaModule,
        canalCorporativoModule,
        tvCorporativaModule,
        tvIndicadoresModule,
        customizationModule,
        profileModule,
        loginModule,
        birthsModule,
        terminos
    },
});